import { render, staticRenderFns } from "./ViewMyTraining.vue?vue&type=template&id=a143fd84&scoped=true"
import script from "./ViewMyTraining.vue?vue&type=script&lang=js"
export * from "./ViewMyTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a143fd84",
  null
  
)

export default component.exports